// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nj-3";
export var downloadButton = "_nj-4";
export var fileContainer = "_nj-9 _nj-7";
export var fileContainerBase = "_nj-7";
export var fileContainerFixedHeight = "_nj-8 _nj-7";
export var fileInfo = "_nj-5";
export var fileInfoWidthRestricted = "_nj-6";
export var fileType = "_nj-1";
export var fileTypeName = "_nj-2";
export var image = "_nj-0";
export var link = "_nj-b";
export var overflowEllipsis = "_nj-a";